@if (progress) {
<div class="app-loading-overlay">
  <cds-progress class="col-xs-12" mode="indeterminate" type="ring" [diameter]="60"></cds-progress>
</div>
}
<div class="table-content l-mt-4">
  @if (_rowInfoList && _rowInfoList.length > 0) {
  <table>
    <!-- <app-loading *ngIf="progress" [overlay]="true"></app-loading> -->
    <caption></caption>
    <tr class="table-title l-pt-2 l-pb-2">
      @if (expandTemplate) {
      <th scope="col" class="icon-width"></th>
      } @for (item of _headerList; track item; let index = $index) {
      <th scope="col" [ngClass]="[item.width ? '' : 'no-warp']">
        <div class="l-d-f l-ai-cen">
          <div class="l-d-ib">
            <span class="cds-h6-demibold">{{ item.label | lang }}</span>
          </div>
          <div class="l-d-ib pointer l-pl-4 l-pr-4">
            @if (item.sort === Sort.DEFAULT) {
            <cds-icon (click)="sortChangeFun(Sort.UP, index)" class="" icon="arrow:sort"></cds-icon>
            } @if (item.sort === Sort.UP) {
            <cds-icon (click)="sortChangeFun(Sort.DOWN, index)" icon="arrow:up"></cds-icon>
            } @if (item.sort === Sort.DOWN && multiSort) {
            <cds-icon (click)="sortChangeFun(Sort.UP, index)" icon="arrow:down"></cds-icon>
            } @if (item.sort === Sort.DOWN && !multiSort) {
            <cds-icon (click)="sortChangeFun(Sort.DEFAULT, index)" icon="arrow:down"></cds-icon>
            }
          </div>
        </div>
      </th>
      }
    </tr>
    @for (row of data; track row; let index = $index) {
    <tr
      (mouseenter)="mouseenterFun(index)"
      (mouseleave)="mouseleaveFun(index)"
      [ngStyle]="{
        background: _rowInfoList[index].expand || _rowInfoList[index].mouseIn ? '#fff' : '#FAFAFA'
      }"
      [ngClass]="[_rowInfoList[index].expand ? 'line-bord-show' : 'line-bord']">
      @if (expandTemplate) {
      <td (click)="trigger(index)" class="icon-width pointer l-pl-4">
        <cds-icon
          (click)="$event.stopPropagation(); trigger(index)"
          [width]="size"
          [height]="size"
          [@openClose]="_rowInfoList[index].expand ? 'expanded' : 'collapsed'"
          [config]="_config"
          [icon]="icon"></cds-icon>
      </td>
      } @for (cell of _rowInfoList[index].data; track cell) {
      <td>
        <div [ngStyle]="{ width: cell.width ? cell.width : '' }">
          @if (cell.template) {
          <ng-container [ngTemplateOutlet]="cell.template" [ngTemplateOutletContext]="{ $implicit: row, index: index }"></ng-container>
          } @if (!cell.template) {
          {{ cell.val || '' }}
          }
        </div>
      </td>
      }
    </tr>
    @if (expandTemplate) {
    <tr [ngClass]="[_rowInfoList[index].expand ? 'line-bord-show' : '']">
      <td class="no-padding">
        <div [@openClose]="_rowInfoList[index].expandClass" class="icon-width"></div>
      </td>
      <td class="no-padding" [colSpan]="_rowInfoList[index].data.length">
        <div [@openClose]="_rowInfoList[index].expandClass">
          <ng-container
            [ngTemplateOutlet]="expandTemplate"
            [ngTemplateOutletContext]="{
              $implicit: row.expandData ? row.expandData : row,
              index: index
            }"></ng-container>
        </div>
      </td>
    </tr>
    } }
  </table>
  } @if (!progress && (!_rowInfoList || _rowInfoList.length === 0)) {
  <div class="l-d-f l-jc-cen l-ai-cen l-pa-4">
    <div>
      <cds-icon class="mirror-rotate-h" [config]="notfoundConfig" icon="form:search"></cds-icon>
    </div>
    <div class="l-ml-6">
      <span class="cds-h2-light font-dark-navy">{{ noResultMsg || 'common.noResultFound' | lang }}</span>
    </div>
  </div>
  }
</div>
<ng-content></ng-content>
